import React from "react";
import autoBind from 'react-autobind';

class TableColumns extends React.Component{
	constructor(props){
		super(props);
		this.state = {
			columns: this.props.values,
			timeFormats: ["yyyy-MM-dd HH:mm:ss", "MM/dd/yyyy H:mm:ss", "dd-MM-yyyy HH:mm:ss", "dd/MM/yyyy HH:mm:ss"]
		};
		autoBind(this)

	}

	populateColumns(){
		let div = document.getElementById("column-choices");
		if (div != null){
			div.innerHTML = '';
		}
		let columns = this.props.columns;
		for (let key in columns) {
			let box = document.createElement("input");
			box.type = "checkbox";
			box.value = JSON.stringify(columns[key]);
			box.name = key;
			box.id = key + "checkbox";
			box.style.marginRight = '10px';
			box.checked = columns[key].Checked;
			box.onchange = function () {
				this.updateBoxes(key, "checkbox");
			}.bind(this);
			let label = document.createElement("label");
			label.style.fontWeight = "normal";
			label.style.display = 'inline';
			label.appendChild(box);
			label.appendChild(document.createTextNode(key));
			let br = document.createElement('br');
			div.appendChild(label);

			if (columns[key].displayMeasurement){
				let dropdownlabel = document.createElement("label");
				dropdownlabel.style.fontWeight = "normal";
				dropdownlabel.appendChild(document.createTextNode("    measured in    "));
				dropdownlabel.style.paddingLeft = '2%';
				var dropdown = this.generateUnitDropDown(columns[key].DataTypeId, key);
				dropdown.id = key + "dropdown";
				dropdown.onchange = function () {
					this.updateBoxes(key, "dropdown");
				}.bind(this);
				dropdownlabel.appendChild(dropdown);
				div.appendChild(dropdownlabel);
			}

			if (columns[key].displayTimeData){
				let timeLabel = document.createElement("label");
				timeLabel.style.fontWeight = "normal";
				timeLabel.appendChild(document.createTextNode("     formatted as     "));
				timeLabel.style.paddingLeft = '2%';
				let formatDropdown = this.generateTimeFormatDropDown(key, this.state.timeFormats);
				let zoneDropdown = this.generateTimeZoneDropDown(key, this.props.timeZones)
				formatDropdown.id = key + "timeFormat";
				formatDropdown.onchange = function () {
					this.updateBoxes(key, "timeFormat", "zoneFormat")
				}.bind(this);
				zoneDropdown.id = key + "zoneFormat";
				zoneDropdown.onchange = function () {
					this.updateBoxes(key, "timeFormat", "zoneFormat")
				}.bind(this);
				timeLabel.appendChild(formatDropdown);
				timeLabel.appendChild(zoneDropdown);
				div.appendChild(timeLabel);
			}


			div.appendChild(br)
		}
	}

	generateUnitDropDown(dataTypeId, name){
		let dropDown = document.createElement("select"); 
		let defOption = document.createElement("option");
		defOption.text = "select unit";
		defOption.value = "";
		defOption.selected = true;
		defOption.disabled = true;
		defOption.hidden = true; 
		dropDown.appendChild(defOption);
		for (let i = 0; i < this.props.units.length; i++) {
			if (this.props.units[i].DataTypeId === dataTypeId){
				let element = document.createElement("option");
				element.value = this.props.units[i].Name;
				element.text = this.props.units[i].Name;
				if (this.props.columns[name].selectedUnit === this.props.units[i].Name){
					defOption.selected = false;
					element.selected = true;
				}
				dropDown.appendChild(element);
			}

		}
		return dropDown;
	}

	generateTimeZoneDropDown(name, values){
		let dropDown = document.createElement("select");
		dropDown.style.width = '135px';
		let defOption = document.createElement("option");
		defOption.text = "select...";
		defOption.value = "";
		defOption.selected = true;
		defOption.disabled = true;
		defOption.hidden = true;
		dropDown.appendChild(defOption);
		for (let i = 0; i < values.length; i++) {
			let element = document.createElement("option");
			element.value = values[i].Abbreviation;
			element.text = values[i].Display;
			if (this.props.columns[name].timeData.selectedTimeZone === values[i].Abbreviation){
				defOption.selected = false;
				element.selected = true;
			}
			dropDown.appendChild(element);

		}
		return dropDown;
	}

	generateTimeFormatDropDown(name, values){
		let dropDown = document.createElement("select");
		let defOption = document.createElement("option");
		defOption.text = "select...";
		defOption.value = "";
		defOption.selected = true;
		defOption.disabled = true;
		defOption.hidden = true;
		dropDown.appendChild(defOption);
		for (let i = 0; i < values.length; i++) {
			let element = document.createElement("option");
			element.value = values[i];
			element.text = values[i];
			if (this.props.columns[name].timeData.selectedTimeFormat === values[i]){
				defOption.selected = false;
				element.selected = true;
			}
			dropDown.appendChild(element);

		}
		return dropDown;
	}

	updateBoxes(name, id1, id2){
		if (id1 === "checkbox"){
			this.props.onCheck(name, document.getElementById(name + id1).checked);
		}
		if (id1 === "dropdown"){
			this.props.onChoice(name, document.getElementById(name+id1).value);
		}
		if (id1 === "timeFormat" && id2 === "zoneFormat"){
			this.props.onTimeSelect(name, document.getElementById(name+id1).value, document.getElementById(name+id2).value)
		}

	}


	render(){
		this.populateColumns();
		return (
			<div id="table-column" style={{flex:'3', display:'flex', flexDirection:'column', height:'50%'}}>
				<label form="column-choices">Available Fields:</label>
				<div id="column-choices">

				</div>
			</div>
		)
	}
}

export default TableColumns;